import script from "./SideMenuInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuInfo.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuInfo.vue?vue&type=style&index=0&id=3e4e49ef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4e49ef"]])

export default __exports__